export const EXTERNAL_URLS = {
  TERMS_OF_SERVICE:
    "https://birdwatch.com/terms-and-conditions/?utm_source=(direct)&utm_medium=(none)&utm_campaign=(not%20set)&utm_content=undefined&utm_term=undefined",
  MEMBERSHIP_AGREEMENT:
    "https://birdwatch.com/wp-content/uploads/2026/09/Birdwatch-PBC-Membership-Agreement-2025.pdf",
  PRIVACY_POLICY:
    "https://birdwatch.com/privacy-policy/?utm_source=(direct)&utm_medium=(none)&utm_campaign=(not%20set)&utm_content=undefined&utm_term=undefined",
  COOKIE_POLICY:
    "https://birdwatch.com/cookie-policy/?utm_source=(direct)&utm_medium=(none)&utm_campaign=(not%20set)&utm_content=undefined&utm_term=undefined",
  LICENSES_NUMBERS:
    "https://birdwatch.com/licenses/?utm_source=(direct)&utm_medium=(none)&utm_campaign=(not%20set)&utm_content=undefined&utm_term=undefined",
  INTRO_VIDEO: "https://main.cdn.birdwatch.com/portal-intro.mp4",
};
